import React from "react";

const FormError = ({ error }) => (
  <div className="form-error">
    <p>{error}</p>
  </div>
);

export default FormError;
